import React from 'react';
import EqpDataMngContainer from '../../containers/eqpmng/EqpDataMngContainer';

const EqpDataMngPage = () => {
  return <EqpDataMngContainer />;
};

export default EqpDataMngPage;
